"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fiave": {
    "b6b5121c": [{
      "hkey": "e63e61be",
      "slug": "fiave",
      "name": "Fiavè",
      "primary": true,
      "skipSearch": false
    }],
    "castelcampo": [{
      "hkey": "e63e61be",
      "slug": "fiave",
      "name": "Fiavè",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ccdb198a": [{
      "hkey": "e63e61be",
      "slug": "fiave",
      "name": "Fiavè",
      "primary": true,
      "skipSearch": false
    }],
    "castil": [{
      "hkey": "e63e61be",
      "slug": "fiave",
      "name": "Fiavè",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "747c52a2": [{
      "hkey": "e63e61be",
      "slug": "fiave",
      "name": "Fiavè",
      "primary": true,
      "skipSearch": false
    }],
    "cornelle": [{
      "hkey": "e63e61be",
      "slug": "fiave",
      "name": "Fiavè",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0a33421f": [{
      "hkey": "15726a83",
      "slug": "doss-torbiera",
      "name": "Doss-Torbiera",
      "primary": true,
      "skipSearch": false
    }],
    "doss": [{
      "hkey": "15726a83",
      "slug": "doss-torbiera",
      "name": "Doss-Torbiera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fiave"
    }],
    "860a03a2": [{
      "hkey": "15726a83",
      "slug": "doss-torbiera",
      "name": "Doss-Torbiera",
      "primary": true,
      "skipSearch": false
    }],
    "torbiera": [{
      "hkey": "15726a83",
      "slug": "doss-torbiera",
      "name": "Doss-Torbiera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fiave"
    }],
    "71929106": [{
      "hkey": "e63e61be",
      "slug": "fiave",
      "name": "Fiavè",
      "primary": true,
      "skipSearch": false
    }],
    "valec": [{
      "hkey": "e63e61be",
      "slug": "fiave",
      "name": "Fiavè",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;